import Indicator, { IndicatorType } from '../../types/Indicator'

const ThinOrange: Indicator = {
  type: IndicatorType.OSCILLATOR,
  value: 'thinOrange',
  label: 'Thin Orange',
  fields: ['thinOrange'],
  excludeSelfInRHS: true,
}

export default ThinOrange
